import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { categories, mainWebsiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const firstCategories = categories.slice(0, 7);
  const secondCategories = categories.slice(7);

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-grid-line text-lg" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-900">{t('brand')}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">{t('footer_tagline')}</p>
            <div className="mt-5">
              <LanguageSwitcher />
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t('footer_explore')}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer">
                  {t('nav_home')}
                </Link>
              </li>
              <li>
                <Link
                  to="/article/usfans-spreadsheet-guide"
                  className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                >
                  {t('article_card_title')}
                </Link>
              </li>
              <li>
                <a
                  href={mainWebsiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                >
                  {t('final_cta_buy')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t('nav_categories')}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {firstCategories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {t(`category_${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t('footer_resources')}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {secondCategories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {t(`category_${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer_disclaimer')}</p>
          <p className="mt-3 text-xs text-foreground-400">
            © {new Date().getFullYear()} USFansSheet.casa · {t('brand')}
          </p>
        </div>
      </div>
    </footer>
  );
}